<template>
  <card id="options">
    <!-- Card header -->

    <b-row align-v="center" slot="header">
      <b-col cols="8">
        <h3 slot="header" class="mb-0">
          <i :class="icon"></i>
          {{ title }}
        </h3>
      </b-col>
    </b-row>

    <!-- Card body -->
    <validation-observer ref="formValidator">
      <form class="needs-validation">
        <b-row>
          <b-col md="12">
            <b-form-checkbox class="mb-3" v-model="offer.option_fahrerschutz">
              Fahrer-Schutzversicherung
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-checkbox
              class="mb-3"
              v-model="offer.option_schutzbrief"
              :disabled="offer.option_schutzbrief_plus"
            >
              Schutzbrief
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row v-if="this.offer.is_car">
          <b-col md="12">
            <b-form-checkbox
              class="mb-3"
              v-model="offer.option_schutzbrief_plus"
              :disabled="offer.option_schutzbrief"
            >
              Schutzbrief plus
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row v-if="this.offer.is_car">
          <b-col md="12">
            <b-form-checkbox
              class="mb-3"
              v-model="offer.option_discount_protection_kh"
              :disabled="this.offer.customer_sf < 10"
            >
              Rabattschutz Haftpflicht (möglich ab SF 10)
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row v-if="this.offer.is_car">
          <b-col md="12">
            <b-form-checkbox
              class="mb-3"
              v-model="offer.option_discount_protection_fv"
              :disabled="!mayHaveDicountProtektionKH()"
            >
              Rabattschutz Kasko (möglich ab SF 10)
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-checkbox class="mb-3" v-model="offer.option_gap">
              GAP - Versicherung
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-checkbox class="mb-3" v-model="offer.option_kex">
              Kasko-Extra-Versicherung
            </b-form-checkbox>
          </b-col>
        </b-row>
      </form>
    </validation-observer>
  </card>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import dateUtil from "../../../services/date";

export default {
  name: "options",
  props: {
    title: "",
    icon: "",
  },
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      loading: false,
      nonkh: [118,119,120,121],
    };
  },
  methods: {
    mayHaveDicountProtektionKH(){
//      console.log("includes = "+this.nonkh.includes(this.offer.participation));
//      console.log("sf gt 10 = "+(this.offer.customer_sf2 >= 10));
        if(this.offer.customer_sf <= 10){
          return false;
        }
        if(this.offer.customer_sf2 >= 10){
//        console.log("includes = "+this.offer.participation);
//        console.log("includes = "+this.nonkh.includes(this.offer.participation));
        if(this.nonkh.includes(this.offer.participation)){
          return false;
        }
        //this.offer.option_discount_protection_fv = 0;
        return true;
      }
      return false;
    },
  },
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      offer: (state) => state.offer,
    }),
  },
  mounted() {},
};
</script>
<style>
</style>